import { Component, Input } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';

import { RtButtonSize } from '../../../../common/button/button.types';
import { IconButtonComponent } from '../../../../common/button/components/icon-button/icon-button.component';
import { RtTooltip } from '../../../../common/tooltip/tooltip.directive';

@Component({
  selector: 'rt-dialog-close',
  styleUrls: ['./dialog-close.component.less'],
  template: `
    <rt-icon-button
      variant="plain-onoverlay"
      [rtTooltip]="closeTooltip! | translate"
      [rtTooltipPosition]="'left'"
      [size]="closeButtonSize"
      iconName="close"
      shape="square"
    />
  `,
  imports: [IconButtonComponent, RtTooltip, TranslatePipe],
})
export class DialogCloseComponent {
  @Input() public closeTooltip?: string = 'rtu.dialog.close_tooltip';
  @Input() public closeButtonSize: Extract<RtButtonSize, 'small' | 'medium' | 'small-x'> = 'medium';
}
